module.exports = __webpack_public_path__ + "static/media/model-sorento-02.958251c6.webp";